import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export default function NotifyListAdmin({ api }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/starter-kit/notify").then((r) => setD(r.data)); }, []);
  const csv = async () => {
    const { data } = await api.get("/admin/starter-kit/notify.csv", { responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(data); a.download = "starter_kit_notify_list.csv"; a.click();
  };
  if (!d) return <p className="text-[#6E6E6E]">Loading…</p>;
  return (
    <div className="space-y-4" data-testid="sk-notify-admin">
      <div className="flex flex-wrap gap-3 items-center">
        <p className="font-head uppercase text-[#1E1E1E]" data-testid="sk-notify-total">{d.total} signups</p>
        <button data-testid="sk-notify-csv" onClick={csv} className="flex items-center gap-1.5 px-3 py-1.5 border-2 border-[#1E1E1E] text-xs font-head uppercase hover:bg-[#F3F1EC]"><Download size={14} /> CSV</button>
      </div>
      <div className="flex flex-wrap gap-2">
        {d.by_sport.map(([s, n]) => <span key={s} className="border-2 border-[#DB9130] px-3 py-1 text-sm font-head uppercase" data-testid={`sk-notify-count-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{s}: {n}</span>)}
      </div>
      <div className="border-2 border-[#D3CFC0] divide-y divide-[#EDE8DC] text-sm">
        {d.rows.slice(0, 200).map((x) => (
          <div key={x.id} className="px-3 py-1.5 flex gap-3"><span className="flex-1">{x.email}</span><span className="text-[#6E6E6E]">{x.sport}{x.age ? ` · ${x.age}` : ""}</span><span className="text-xs text-[#9A9A9A]">{new Date(x.created_at).toLocaleDateString()}</span></div>
        ))}
      </div>
    </div>
  );
}
